import * as z from "zod";

export const deleteBundle = {
  name: "deleteBundle" as const,
  input: z.object({ parentVariantId: z.string().min(1) }),
  output: z.object({ success: z.literal(true) }),
};
